<template>
    <el-dialog class="el-dialogs" :title="title" :close-on-click-modal="false"
               :visible.sync="visible" width="400px">
        <div class="dialogCont">
            <el-checkbox-group v-model="removeList" v-if="dataList.length">
                <div v-for="item in dataList" :key="item.allId" class="itemBject">
                    <el-checkbox :label="item.allId">{{ item.thematicName }}</el-checkbox>
                </div>
            </el-checkbox-group>
            <el-empty :image-size="80" style="margin-top: 70px" v-else></el-empty>
        </div>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="submit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>

export default {
    name: "removeSubject",
    data() {
        return {
            title: '移除资源专题',
            visible: false,
            removeList: [],
            dataList: [],
            selectList: [],//选中的数据
        }
    },

    methods: {
        //typeName view详情 edit编辑 toExamineView审核详情
        init(selectList) {
            this.visible = true
            this.removeList = []
            this.selectList = selectList.map(item=>{
                return item.id
            })
            this.getDetail()
        },

        getDetail(){
            this.$axios(this.api.academic.relevancedataQueryRemoveThematicList, this.selectList, 'post').then(data => {
                if (data.status) {
                    this.dataList = data.data
                    this.dataList.forEach(item=>{
                        this.$set(item,'allId',item.thematicId + item.resourcesId)
                    })
                } else {
                    this.$message.error('查询失败');
                }
            })
        },

        //保存
        submit() {
            if (this.removeList.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let deleteList = []
            this.dataList.forEach(item=>{
                this.removeList.forEach(item2=>{
                    if (item.allId == item2){
                        deleteList.push(item.thematicId)
                    }
                })
            })
            this.$confirm(`移除后不可恢复，是否继续`, '确认移除所选资源的专题?',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.relevancedataRemoveByRelevanceData, {
                    resourcesIdList:this.selectList,
                    thematicIdList:deleteList,
                    dataType:0,
                    }, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success(`移除成功`)
                        this.$emit('refresh')
                        this.visible = false
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}

.dialogCont {
    padding: 0 20px;
    height: 300px;
    overflow-y: auto;
}

.itemBject {
    margin-bottom: 10px;
}

</style>